import { TildeIcon } from '@phosphor-icons/react';
import { IconArrow, IconRenderer } from 'braid-design-system';

export const Difference = ({
  signum,
  formatted,
}: {
  signum: number;
  formatted: string;
}) => {
  if (signum > 0) {
    return (
      <>
        <IconArrow direction="up" /> {formatted} more than
      </>
    );
  }

  if (signum < 0) {
    return (
      <>
        <IconArrow direction="down" /> {formatted} less than
      </>
    );
  }

  return (
    <>
      <IconRenderer>
        {({ className }) => <TildeIcon className={className} />}
      </IconRenderer>{' '}
      similar to
    </>
  );
};
